import { Platform } from '@angular/cdk/platform';
import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit  } from '@angular/core';
import { MatDialogRef, MatTabGroup, MAT_DIALOG_DATA } from '@angular/material';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import dayjs from 'dayjs';
import { DateFormat } from 'src/app/core/class/date-format';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-view-properties-original-dialog',
  styleUrls: ['./view-properties-original-dialog.component.scss'],
  templateUrl: './view-properties-original-dialog.component.html',
  providers: [
    // DateFormat,
    { provide: MAT_DATE_LOCALE, useValue: 'vi' },
    {
      provide: DateAdapter,
      useClass: DateFormat,
      deps: [MAT_DATE_LOCALE, Platform],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ViewPropertiesOriginalDialogApproveComponent implements OnInit, AfterViewInit {
  listDataSource: any[] = [];
  listDataUpdateSource: any[] = [];
  customerMohaId: any = null
  customerMohaName: any = null
  listCustomer: any[] = [];
  listColumnVersionHistory: string[] = [];
  listDataVersionHistory: any[] = [];
  optionsMap = new Map<number, any[]>();
  displayedColumns = ["stt", "nameCriteria", "infoTemplate"];
  displayedHistoryColumns: string[] = []
  isOriginalContract: boolean = false;
  titleChange: string = '';
  @ViewChild('myTabGroup', { static: false }) myTabGroup: MatTabGroup;
  @ViewChild('inputName', { static: false }) inputName: ElementRef;
  isInforTab = 0
  fieldMap = new Map<string, any>()

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewPropertiesOriginalDialogApproveComponent>,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
  }

  ngOnInit() {
    this.listDataUpdateSource = this.data.listDataUpdateSource
    this.listDataSource = this.data.listDataSource
    this.customerMohaId = this.data.customerMohaId
    this.customerMohaName = this.data.customerMohaName
    this.listCustomer = this.data.listCustomer
    this.optionsMap = this.data.optionsMap
    this.isOriginalContract = this.data.isOriginalContract;
    this.titleChange = this.data.titleChange;
    this.listDataVersionHistory = this.data.listDataVersionHistory;
    this.buildColumns(this.data.listColumnVersionHistory)
    this.initFieldMap(this.data.listColumnVersionHistory)
  }

  ngAfterViewInit() {
    this.dialogRef.afterOpened().subscribe(() => {
      setTimeout(() => {
        const activeEl = document.activeElement as HTMLElement;
        activeEl.blur();
      });
    });
  }


  initFieldMap(dataStandard: any[]) {
    dataStandard.forEach(f => {
      this.fieldMap.set(f.code, f)
    })
  }

  getField(code: string) {
    return this.fieldMap.get(code)
  }


  buildColumns(dataStandard: any[]) {
    this.displayedHistoryColumns = dataStandard
      .filter(x => x.code)
      .map(x => x.code)
  }

  onNoClick() {
    this.dialogRef.close();
  }

  getFormatDate(date: string) {
    return dayjs(date).format('DD/MM/YYYY')
  }

  getDataDropdown(data: any, value: string) {
    const listMetadata = JSON.parse(data.metadata);
    let valueView = listMetadata.find(e => e.value == value || e.value == value.toString());
    return valueView ? valueView.name : '';
  }
}
